import postAPI from './postAPI.js'

export default async function getActionVariables(payload = {}) {
    const data = await postAPI('admin/taskflows/actions/variables', payload);
    return data;
}
